import { JSONSchemaType } from 'ajv'

export interface IUserGroupFormData {
  id: string
  name: string
  disabled: boolean
}

const UserGroupSchema: JSONSchemaType<IUserGroupFormData> = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    disabled: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['name'],
  additionalProperties: false,
}

export default UserGroupSchema
